module.exports = __webpack_public_path__ + "media/src/img/payment/uniteller_logo-ac3812b9a2c159b5910c5d73ccc345a4.svg";